const resumeData = {
  name: "Denzil Martin",
  fullName: "Denzil Martin Joseph Antony Prabhu",
  title: "Senior Software Engineer · Full Stack & Applied AI",
  profileImage: "/assets/images/profile1.jpg",
  resumePdf: "/assets/Denzil_Martin_Resume.pdf",
  positioning: "Munich · Full stack · Applied AI",
  headline: "Enterprise platforms. Practical AI.",
  introduction:
    "Senior software engineer with 10+ years building secure full-stack systems for Allianz, AXA, and other enterprise clients across Europe and India. I combine hands-on engineering with technical leadership, plus practical work in RAG, agents, and developer automation.",
  openTo:
    "Open to Senior Software Engineer / Full Stack roles in Germany or remote-EU — including technical leadership tracks that blend delivery with applied AI.",
  contact: {
    email: "den05mar12@gmail.com",
    linkedin: "https://www.linkedin.com/in/denzil-martin/",
    linkedinLabel: "linkedin.com/in/denzil-martin",
    xing: "https://www.xing.com/profile/Denzil_Joseph083755",
    location: "Munich, Germany",
  },
  currentlyExploring: "AI agents · RAG · Context engineering",
  quickStats: [
    { value: "10+", label: "Years in software" },
    { value: "3", label: "Countries onsite" },
    { value: "5", label: "Enterprise programmes" },
  ],
  expertise: [
    {
      title: "Frontend Platforms",
      items: ["Angular", "React", "TypeScript", "Micro frontends", "PWAs", "NgRx / RxJS"],
    },
    {
      title: "Backend & Cloud",
      items: ["Java / Spring Boot", "Node.js", "Python", "REST", "Azure", "AWS", "Docker", "Kubernetes"],
    },
    {
      title: "Security & Identity",
      items: ["OAuth 2.0", "JWT", "Microsoft Entra ID", "Azure AD B2C", "XSS / CSRF"],
    },
    {
      title: "AI & Leadership",
      items: ["RAG", "LangChain", "AI agents", "Flowise", "MCP", "Team guidance", "Client delivery"],
    },
  ],
  industries: [
    { name: "Insurance", clients: ["Allianz", "AXA", "The Hartford"] },
    { name: "Banking", clients: ["Standard Bank"] },
    { name: "Energy & Agriculture", clients: ["BayWa"] },
  ],
  aiFocus: [
    {
      title: "Documentation Q&A (RAG)",
      status: "Prototype",
      description:
        "LangChain + Python + vector store prototype during Allianz work — grounded answers for faster developer onboarding.",
      tools: ["LangChain", "Python", "RAG"],
    },
    {
      title: "Agents with tools & memory",
      status: "Exploration",
      description:
        "Flowise agent prototypes combining LLMs, tools, and memory, with careful context engineering.",
      tools: ["Flowise", "Agents", "Context"],
    },
    {
      title: "AI in daily engineering",
      status: "Applied",
      description:
        "GitHub Copilot in delivery, AI-assisted support triage experiments, and MCP exploration for tool/API wiring.",
      tools: ["Copilot", "Support AI", "MCP"],
    },
  ],
  experience: [
    {
      period: "Jan 2025 – Present",
      role: "Senior Technical Lead",
      company: "Cognizant",
      client: "BayWa",
      location: "Munich, Germany",
      highlights: [
        "Lead technical operations for BayWa’s Staffbase employee platform: access, incidents, and release coordination.",
        "Prototype AI-assisted support workflows to cut repetitive queries and speed triage.",
        "Ship targeted frontend/content customisations with vendor and internal partners.",
      ],
    },
    {
      period: "Nov 2021 – Dec 2024",
      role: "Senior Technical Lead",
      company: "Cognizant",
      client: "Allianz",
      location: "Munich, Germany",
      highlights: [
        "Led Cockpit delivery and the Letterhead micro frontend (Angular + Spring Boot).",
        "Hardened access with Azure AD B2C, OAuth 2.0, and XSS/CSRF protections; CI/CD via Azure DevOps, Docker, Kubernetes.",
        "Prototyped LangChain documentation Q&A and an MQTT smart-home alerts POC for insurance use cases.",
      ],
    },
    {
      period: "Nov 2019 – Nov 2021",
      role: "Technical Lead",
      company: "Cognizant",
      client: "AXA",
      location: "Brussels, Belgium",
      highlights: [
        "Modernised AXA’s insurance portal with Angular, responsive UX, and NgRx.",
        "Ran GraphQL and micro-frontend POCs; automated AWS delivery with Jenkins, Docker, and Kubernetes.",
      ],
    },
    {
      period: "Jan 2015 – Nov 2019",
      role: "Frontend Developer",
      company: "Cognizant · Wipro",
      location: "Chennai, India",
      highlights: [
        "Built Angular PWAs and secure banking/insurance frontends with reusable components and solid unit-test coverage.",
        "Partnered with backend teams on REST integration and frontend quality through reviews.",
      ],
    },
  ],
  projects: [
    {
      name: "Allianz Cockpit & Letterhead",
      category: "Full-stack · Identity",
      description:
        "Enterprise Cockpit plus Angular/Spring Boot Letterhead micro frontend with Azure AD B2C. MQTT dashboard POC for smart-home insurance alerts.",
      impact: "Secure micro-frontend architecture and cloud-native CI/CD on Azure.",
      tools: ["Angular", "Spring Boot", "Azure AD B2C", "Kubernetes"],
    },
    {
      name: "AXA Insurance Portal",
      category: "Modernisation",
      description:
        "Portal modernisation with Angular and NgRx; GraphQL and micro-frontend architecture POCs.",
      impact: "Stronger state management, responsive UX, automated AWS delivery.",
      tools: ["Angular", "NgRx", "AWS", "Kubernetes"],
    },
    {
      name: "BayWa Staffbase App",
      category: "Platform ops · AI support",
      description:
        "Technical operations for the employee communications platform, with AI-assisted triage experiments.",
      impact: "Stable operations and faster support handling.",
      tools: ["Staffbase", "SSO", "AI tooling"],
    },
  ],
  earlierProjects: [
    {
      name: "The Hartford Policy Generation Engine",
      summary: "Angular policy generation with SCSS and Jasmine coverage.",
    },
    {
      name: "Standard Bank Banking Application",
      summary: "Secure Angular replacement for a legacy banking experience.",
    },
  ],
  certifications: [
    { name: "Microsoft Azure AI Fundamentals", code: "AI-900", year: "2025" },
    { name: "Microsoft Azure Fundamentals", code: "AZ-900", year: "2023" },
    { name: "AWS Certified Cloud Practitioner", code: "AWS", year: "2021" },
  ],
  education: {
    degree: "B.E. Computer Science",
    institution: "Anna University, Chennai",
    period: "2011 – 2015",
    result: "CGPA 8.52/10",
  },
  languages: "English · Tamil · German (towards B1)",
  interests: "Tennis, travel, food across cultures, mentoring junior developers.",
};

export default resumeData;
